module.exports = __webpack_public_path__ + "img/footer-by-zumasys.2a11b156.png";